import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { theme } from '../theme';
import * as analytics from '../lib/analytics';
import { parseInviteLink } from '../utils/parseInviteLink';

interface Props {
  onClose: () => void;
}

export default function PasteInviteLinkModal({ onClose }: Props) {
  const navigate = useNavigate();
  const [value, setValue] = useState('');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = () => {
    const token = parseInviteLink(value);
    analytics.track('group_paste_link_submitted', { valid: !!token, platform: 'web' });
    if (!token) {
      setError('El link no parece de Futbolero. Pegalo completo.');
      return;
    }
    onClose();
    navigate(`/join-group/${token}`);
  };

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 2000,
        padding: 16,
      }}
      data-testid="paste-invite-modal-overlay"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: theme.colors.surface,
          borderRadius: theme.borderRadius.card,
          padding: 24,
          maxWidth: 480,
          width: '100%',
          boxShadow: '0 12px 40px rgba(0,0,0,0.25)',
        }}
        data-testid="paste-invite-modal"
      >
        <h3 style={{ margin: '0 0 8px 0', color: theme.colors.text, fontSize: 20 }}>
          Pegá tu link de Futbolero
        </h3>
        <p style={{ margin: '0 0 16px 0', color: theme.colors.textSecondary, fontSize: 13 }}>
          Te lo pasaron por WhatsApp o donde sea. Lo unimos por vos.
        </p>
        <input
          type="text"
          value={value}
          onChange={(e) => { setValue(e.target.value); setError(null); }}
          placeholder="https://my-futbol-app.vercel.app/join-group/..."
          autoFocus
          onKeyDown={(e) => { if (e.key === 'Enter') handleSubmit(); }}
          style={{
            width: '100%',
            padding: '12px 14px',
            border: `1px solid ${error ? theme.colors.danger : theme.colors.border}`,
            borderRadius: theme.borderRadius.button,
            fontSize: 14,
            fontFamily: theme.fonts.body,
            boxSizing: 'border-box',
          }}
          data-testid="paste-invite-input"
        />
        {error && (
          <div style={{ marginTop: 8, color: theme.colors.danger, fontSize: 13 }} data-testid="paste-invite-error">
            {error}
          </div>
        )}
        <div style={{ marginTop: 20, display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: '10px 16px',
              background: 'transparent',
              color: theme.colors.textSecondary,
              border: `1px solid ${theme.colors.border}`,
              borderRadius: theme.borderRadius.button,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            style={{
              padding: '10px 18px',
              background: theme.colors.primary,
              color: theme.colors.background,
              border: 'none',
              borderRadius: theme.borderRadius.button,
              fontWeight: 700,
              cursor: 'pointer',
            }}
            data-testid="paste-invite-submit"
          >
            Unirme
          </button>
        </div>
      </div>
    </div>
  );
}
